import ApiAuthenticationExample from "./ApiAuthenticationExample";

export default ApiAuthenticationExample;
